<div class="header">
  <div class="title">Add Suite/Unit</div>
  <button class="close-button" mat-icon-button (click)="discard()" [tabIndex]="-1">
    <mat-icon [svgIcon]="'close'"></mat-icon>
  </button>
</div>
<form [formGroup]="propertyUnitForm">
  <!-- Subject -->
  <div class="flex flex-col gt-xs:flex-row mt-3">
    <mat-form-field class="subject flex-auto">
      <mat-label>Suite Name/Unit #</mat-label>
      <input matInput [formControlName]="'unit_number'" />
    </mat-form-field>
  </div>
  <div class="flex flex-col gt-xs:flex-row mt-3">
    <mat-form-field class="subject flex-auto">
      <mat-label>Square Feet</mat-label>
      <input matInput formControlName="unit_size" [value]="propertyUnitForm.get('unit_size').value | formatNumber: 0" />
    </mat-form-field>
  </div>
  <div class="flex flex-col gt-xs:flex-row mt-3">
    <mat-form-field class="subject flex-auto">
      <mat-label>Floor</mat-label>
      <input matInput [formControlName]="'floor'" />
    </mat-form-field>
  </div>

  <!-- Body -->

  <div class="actions">
    <div class="formatting"></div>

    <div class="buttons">
      <!-- Discard -->
      <button class="discard-button" mat-button type="button" (click)="discard()">
        <span>Cancel</span>
      </button>

      <!-- Send -->
      <button
        class="send-button"
        mat-flat-button
        [color]="'primary'"
        type="submit"
        [disabled]="propertyUnitForm.invalid"
        (click)="save()"
      >
        <span *ngIf="!propertyUnitForm.disabled">Save</span>
        <mat-progress-spinner
          *ngIf="propertyUnitForm.disabled"
          [diameter]="24"
          [mode]="'indeterminate'"
        ></mat-progress-spinner>
      </button>
    </div>
  </div>
</form>
